import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

/**
 * `/explorer` index. The section has no dedicated overview, so landing on the
 * root forwards to the first tab (Products).
 */
// Declares the section-wide subsidiary scope (`sc`) so it can be forwarded through
// the redirect below instead of being dropped on the section root.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/explorer/')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    // TanStack Router uses throw redirect() as control flow — not an error.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/explorer/products',
      // Carry the picked subsidiary through the hop, or landing on
      // `/explorer?sc=X` would silently reset the scope to the own tenant.
      search: search.sc ? { sc: search.sc } : {},
    });
  },
});
